module.exports = __webpack_public_path__ + "img/candidate1.da268b5f.jpg";